// SPDX-License-Identifier: MIT
//
// "Autres IA — à venir" provider showcase for /connecter.
// Displays Claude as the live provider and future providers with a "bientôt"
// badge. Uses stylized monogram glyphs (NOT brand logos — trademark safety).
// Real logos/partnership copy waits for PARTNERSHIP_CONFIRMED=true in brand.ts.
import { t } from '../i18n/t';
import { escapeHtml } from '../lib/escape';

const PROVIDERS = [
  { id: 'claude', glyph: 'C', live: true },
  { id: 'openai', glyph: 'O', live: false },
  { id: 'gemini', glyph: 'G', live: false },
  { id: 'mistral', glyph: 'M', live: false },
  { id: 'llama', glyph: 'L', live: false },
  { id: 'ailab', glyph: 'AI', live: false },
  { id: 'ollama', glyph: 'Ω', live: false },
] as const;

export function renderConnectSoon(): HTMLElement {
  const el = document.createElement('section');
  el.className = 'connect-soon';
  el.setAttribute('data-component', 'connect-soon');
  const cards = PROVIDERS.map((p) => `
    <div class="connect-soon__card" data-provider="${p.id}" data-state="${p.live ? 'live' : 'soon'}">
      <span class="connect-soon__glyph" aria-hidden="true">${p.glyph}</span>
      <span class="connect-soon__name">${escapeHtml(t(`connecter.soon.providers.${p.id}`))}</span>
      <span class="connect-soon__state">${escapeHtml(p.live ? t('connecter.soon.live') : t('connecter.soon.comingSoon'))}</span>
    </div>`).join('');
  el.innerHTML = `
    <h3 class="connect-soon__h">${escapeHtml(t('connecter.soon.heading'))}</h3>
    <p class="connect-soon__lead">${escapeHtml(t('connecter.soon.lead'))}</p>
    <div class="connect-soon__grid">${cards}</div>`;
  return el;
}
